import React from "react";
import { useNavigate } from "react-router-dom";
import { useOrderExport } from "../hooks/useOrderExport";
import { useOrderExportValidation } from "../hooks/useOrderExportValidation";
import { ExportPageHeader } from "../components/ExportPageHeader";
import { ExportConfigurationCard } from "../components/ExportConfigurationCard";
import { ExportDateRangeCard } from "../components/ExportDateRangeCard";
import { ExportTemplateCard } from "../components/ExportTemplateCard";
import { ExportActions } from "../components/ExportActions";
import { ExportStatusAlert } from "../components/ExportStatusAlert";
import { ExportResultCard } from "../components/ExportResultCard";
import ContentHeader from "../../../../layouts/content/ContentHeader";
import { OrderExportErrorModal } from "../components/OrderExportErrorModal";

const OrderExportPage: React.FC = () => {
  const navigate = useNavigate();
  const state = useOrderExport();
  const { errors, showErrors } = useOrderExportValidation(state.form, state.submitted);
  const invalid = (key: keyof typeof errors) => showErrors && !errors[key];

  return <main className="tw-flex tw-h-full tw-min-h-0 tw-flex-col tw-overflow-hidden tw-bg-white dark:tw-bg-slate-900" data-testid="export-order">
    <ContentHeader title="Export orders" subtitle="Create an order export" showSearch={false} buttons={[{ text: "Learn more", onClick: () => navigate("/order/export/information"), variant: "secondary", "data-testid": "learn-more-btn" }]} />
    <div className="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col tw-overflow-y-auto tw-p-4 md:tw-p-8">
      <ExportPageHeader />
    <ExportStatusAlert error={state.error} />
    <OrderExportErrorModal error={state.error} onClose={state.clearError} />
    <div className="tw-flex tw-flex-col tw-gap-4" data-testid="export-order-form">
      <ExportDateRangeCard form={state.form} update={state.update} invalid={invalid("range")} />
      <ExportConfigurationCard form={state.form} accounts={state.accounts} warehouses={state.warehouses} update={state.update} errors={errors} showErrors={showErrors} />
      <ExportTemplateCard form={state.form} update={state.update} templates={state.templates} file={state.file} fileName={state.fileName} setFile={state.setFile} upload={state.upload} uploading={state.uploading} invalid={invalid("template")} />
      <div className="tw-mt-6 tw-flex tw-justify-end tw-border-t tw-border-slate-200 tw-pt-6 dark:tw-border-slate-700"><ExportActions onExport={state.submit} disabled={false} processing={state.processing} /></div>
      <ExportResultCard url={state.resultUrl} onClose={() => state.setResultUrl(undefined)} />
    </div>
    </div>
  </main>;
};
export default OrderExportPage;
